import "./data/results/summary";
import "./data/results/promo_overview";
import mock from "./mock";

mock.onAny().passThrough(); // forwards the matched request over network
